export default __webpack_public_path__ + "static/media/suninfield.6f710db2.jpg";